import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const CertificationDrawerAtom = mediatorAtom<{ isOpen: boolean; filterId?: number }>({ isOpen: false });

export default function useCertificationDrawer() {
    return useMediatorState(CertificationDrawerAtom);
}
